/**
 * cc-gallery-swipe.js
 *
 * Mobile swipe support for the CC Main Product image gallery.
 *
 * When the user swipes left or right on the featured image:
 *   1. The displayed image advances to the next/prev thumbnail.
 *   2. The corresponding color swatch is clicked, which runs the existing
 *      swatch→variant pipeline (price update, URL ?variant= update,
 *      availability state, active swatch highlight).
 *
 * If a thumbnail has no data-color attribute (fallback media not tied to a
 * variant), only the image swaps — no swatch/variant change.
 *
 * Mobile-only: the touch handlers fire only when horizontal delta > vertical
 * delta and horizontal delta > SWIPE_THRESHOLD px. Desktop pointer events
 * are unaffected. No library dependency.
 */

(function () {
  'use strict';

  var SWIPE_THRESHOLD = 50; // px — minimum horizontal travel to register a swipe

  function initGallerySwipe(section) {
    var galleryEl = section.querySelector('.cc-main-product__featured-image');
    if (!galleryEl) return;

    var thumbnailList = section.querySelector('.cc-main-product__thumbnails');
    if (!thumbnailList) return;

    var touchStartX = 0;
    var touchStartY = 0;
    var isSwiping = false;

    galleryEl.addEventListener('touchstart', function (e) {
      // Only track single-finger touches
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = true;
    }, { passive: true });

    galleryEl.addEventListener('touchmove', function (e) {
      if (!isSwiping || e.touches.length !== 1) return;

      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;

      // If vertical movement dominates, abandon — let the page scroll
      if (Math.abs(dy) > Math.abs(dx)) {
        isSwiping = false;
      }
    }, { passive: true });

    galleryEl.addEventListener('touchend', function (e) {
      if (!isSwiping) return;
      isSwiping = false;

      var endX = e.changedTouches[0].clientX;
      var endY = e.changedTouches[0].clientY;
      var dx = endX - touchStartX;
      var dy = endY - touchStartY;

      // Must be predominantly horizontal and exceed threshold
      if (Math.abs(dy) >= Math.abs(dx)) return;
      if (Math.abs(dx) < SWIPE_THRESHOLD) return;

      var direction = dx < 0 ? 'next' : 'prev';
      navigateGallery(section, thumbnailList, direction);
    }, { passive: true });
  }

  function navigateGallery(section, thumbnailList, direction) {
    var thumbs = Array.from(thumbnailList.querySelectorAll('.cc-main-product__thumbnail'));
    if (thumbs.length < 2) return;

    var activeIndex = thumbs.findIndex(function (t) {
      return t.classList.contains('is-active');
    });

    // If nothing is marked active, treat first as active
    if (activeIndex === -1) activeIndex = 0;

    var targetIndex;
    if (direction === 'next') {
      targetIndex = activeIndex + 1;
      if (targetIndex >= thumbs.length) return; // already at last image
    } else {
      targetIndex = activeIndex - 1;
      if (targetIndex < 0) return; // already at first image
    }

    var targetThumb = thumbs[targetIndex];
    var color = targetThumb.getAttribute('data-color');

    if (color) {
      // Find the swatch that owns this color and click it.
      // The swatch click handler (in cc-main-product.liquid) updates
      // price, URL, availability, active swatch state, then clicks
      // the matching thumbnail to swap the image. This covers everything.
      var safeColor = color.replace(/"/g, '\\"');
      var swatchEl = section.querySelector(
        '.cc-main-product__swatch[data-color-value="' + safeColor + '"]'
      );
      if (swatchEl) {
        swatchEl.click();
        return;
      }
    }

    // Fallback: no swatch found (thumbnail not tied to a variant color).
    // Directly click the thumbnail so only the image swaps.
    targetThumb.click();
  }

  function init() {
    var sections = document.querySelectorAll('.cc-main-product');
    sections.forEach(function (section) {
      initGallerySwipe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
